import PropTypes from 'prop-types';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';

export default PropTypes.oneOf(Object.values(LanguageRegionCode));
